<template>
	<section>
        <div class="margin-top-10">
            <vForm label-width="150" class="margin-15 clearfix" ref="form">
                <vCol span='12'>
                    <vFormItem label="SKU">
                        {{formData.sku}}
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem label="原库存类型">
                        {{formData.inventoryType === 0 ? '可售库存' : '不可售库存'}}
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem label="建议处理方式/更换后SKU">
                        {{this.findRenderLabel(this.getHandleType, formData.goodsReturnType)|| '--'}}/{{formData.newSku||'--'}}
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem label="计划数量/已处理数量">
                        {{formData.qty|| '--'}}/{{formData.qtyDone}}
                    </vFormItem>
                </vCol>
                <vCol span='12' v-if="formData.goodsReturnType !=2 ">
                    <vFormItem label="处理后库存类型">
                        {{formData.afterInventoryType === 0 ? '可售库存' : '不可售库存'}}
                    </vFormItem>
                </vCol>
                <vCol span='12'>
                    <vFormItem label="处理数量" :rules="required" prop="processQty">
                        <vInputNumber v-model="formData.processQty" :min="0" :max="formData.qty-formData.qtyDone"></vInputNumber>
                    </vFormItem>
                </vCol>
            </vForm>
            <vButtonGroup class="text-right">
                <vButton class="margin-right-10" theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
                <vButton @click="cancel">{{$t('global.common.operate_cancel', { defaultValue: "取消" })}}</vButton>
            </vButtonGroup>
		</div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>
		</compModal>
	</section>
</template>

<script>
import { HttpReturnProcessPlanHandle } from '@/service/salesreturns';
import mixin from "../mixin";
import { mapGetters } from 'vuex';
export default {
	mixins: [mixin],
    props: ["params"],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("@components/templates/log"),
		compModal: () => import("@components/templates/modal"),
	},
	data() {
		return {
			loading: false,
			headId: this.params.obj.id,
			formData: {
            },
			modalProps: {
				show: false,
			},
		};
	},
	created() {
        this.formData=this.params.obj
        this.formData.processQty=this.formData.qty-this.formData.qtyDone
	},
	computed: {
        ...mapGetters('dictionary', []),
        required () {
            return [
                {
                    required: true,
                    message: this.$t('global.common.fill_required', { defaultValue: '请填写必填项' })
                }
            ]
        },
	},
	methods: {
        clear(){
            this.formData.newProductId='';
            this.formData.newsku='';
        },
        async submit(){
            let flag = true;
                await this.$refs.form.validate(valid => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            HttpReturnProcessPlanHandle({itemId: this.headId, processQty: this.formData.processQty}).then(res=>{
                this.loading = false;
                this.$emit('on-success')
            }).catch(err => {
                this.$VMessage.error(err.message);
                this.loading = false;
            });
        },
		cancel() {
            this.$emit('on-success')
		}
	}
};
</script>
